<script setup>
const props = defineProps({
  linksCol1: Array,
  linksCol2: Array,
  linksCol3: Array,
  text: String,
});
</script>

<template>
  <footer>
    <div class="l-container p-section">
      <div class="l-row">
        <!-- col 1 -->
        <div class="w-full md:w-1/4 p-col text-white">
          <ul v-if="linksCol1" class="text-white mb-xl">
            <li v-for="link in linksCol1" class="mb-xxs flex">
              <a class="link" :href="link.url" :target="link.target">{{ link.text }}</a>
            </li>
          </ul>
        </div>

        <!-- col 2 -->
        <div class="w-full md:w-1/4 p-col mb-xl">
          <ul v-if="linksCol2" class="text-white mb-xl">
            <li v-for="link in linksCol2" class="mb-xxs flex">
              <a class="link" :href="link.url" :target="link.target">{{ link.text }}</a>
            </li>
          </ul>
        </div>
        <!-- col 3 -->
        <div class="w-full md:w-1/4 p-col mb-xl">
          <ul v-if="linksCol3" class="text-white mb-xl">
            <li v-for="link in linksCol3" class="mb-xxs flex">
              <a class="link" :href="link.url" :target="link.target">{{ link.text }}</a>
            </li>
          </ul>
        </div>
        <!-- col 4 -->
        <div class="w-full md:w-1/4 p-col text-white">
          <div v-if="text" v-html="text" class="prose footer mb-md"></div>
          <a
            href="https://www.instagram.com/wearehellosunshine/"
            target="_blank"
            class="flex items-center transition cursor-pointer mb-xs"
            aria-label="Ga naar Instagram"
          >
            <span class="mr-xs">
              <IconInstagram />
            </span>
            <span class="link">Instagram</span>
          </a>
          <a
            href="https://www.linkedin.com/company/hello-sunshine/"
            target="_blank"
            class="flex items-center transition cursor-pointer group"
            aria-label="Ga naar LinkedIn"
          >
            <span class="mr-xs">
              <IconLinkedin />
            </span>
            <span class="link">Linkedin</span>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<style>
.prose {
  &.footer {
    a {
      text-decoration: none;
      cursor: pointer;
      font-size: 18px;
      position: relative;
      white-space: nowrap;
      color: white;
      display: inline-block;

      &::before {
        content: "";
        @apply bg-yellow;
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
        height: 1px;
        pointer-events: none;

        transform-origin: 100% 50%;
        transform: scaleX(0);
        transition: transform 0.3s ease;
      }

      &:hover::before {
        transform-origin: 0% 50%;
        transform: scaleX(1);
      }
    }
  }
}
</style>
